import LoginPage from '../pages/container/login'
import AddPatientPage from "../pages/container/addPatient";
import { APP_ROUTS } from '../common/constants/constants'

// Contains all unprotected routes
export const unProtectedRoute = [
  { path: APP_ROUTS.ROOT, component: LoginPage, exact: true },
  { path: APP_ROUTS.LOGIN, component: LoginPage, exact: true },
];

// Contains all the routes that needs login
export const protectedRoute = [
  { path: APP_ROUTS.ADD_PATIENT, component: AddPatientPage, exact: true },
];
